import { signAsync } from '@noble/secp256k1';
import { keccak_256 } from '@noble/hashes/sha3';
export { getPublicKey } from '@noble/secp256k1';
export class API {
    endpoint;
    fetchFunction;
    constructor(endpoint, options) {
        this.endpoint = endpoint;
        this.fetchFunction =
            options?.fetch || (typeof window !== 'undefined' ? window.fetch.bind(window) : fetch);
    }
    async call(path, action, options) {
        const headers = {
            'content-type': 'application/json'
        };
        const body = JSON.stringify(action);
        if (options) {
            if ('privateKey' in options) {
                const signature = await signAsync(keccak_256(body), options.privateKey); // Sync methods below
                headers.SIGNATURE = `${signature.toCompactHex()}:${signature.recovery}`;
            }
            else {
                headers.SIGNATURE =
                    'signature' in options ? options.signature : `FAKE:${options.publicKey}`;
            }
        }
        const url = this.endpoint + '/api' + path;
        console.log({ url });
        const resp = await this.fetchFunction(url, {
            method: 'POST',
            body,
            headers
        });
        if (resp.status !== 200 && resp.status !== 201) {
            const text = await resp.text();
            console.error(`failed`, text);
            throw new Error(text);
        }
        if (resp) {
            const json = (await resp.json());
            console.log({ json });
            return json;
        }
        else {
            console.error(`failed with no response`);
            throw new Error(`no response`);
        }
    }
    async register(action, options) {
        return this.call('/user/register', action, options);
    }
    async editUser(action, options) {
        return this.call('/user/editUser', action, options);
    }
    async sendMessage(action, options) {
        return this.call('/private/sendMessage', action, options);
    }
    async getConversations(action, options) {
        return this.call('/private/getConversations', action, options);
    }
    async getAcceptedConversations(action, options) {
        return this.call('/private/getAcceptedConversations', action, options);
    }
    async getUnacceptedConversations(action, options) {
        return this.call('/private/getUnacceptedConversations', action, options);
    }
    async acceptConversation(conversation, options) {
        return this.call('/private/acceptConversation', conversation, options);
    }
    async getMessages(chat, options) {
        return this.call('/private/getMessages', chat, options);
    }
    async getUser(action) {
        return this.call('/user/getUser', action);
    }
    async getCompleteUser(action) {
        return this.call('/user/getCompleteUser', action);
    }
    async clear() {
        return this.call('/admin/db-reset', { reset: true });
    }
}
